import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PROPERTY_QUERY = gql`
  query property($propertyId: Int!) {
    property(propertyId: $propertyId) {
      ...property
      propertyContexts {
        ...propertyContext
      }
      propertyUserGroups {
        ...propertyUserGroup
      }
      propertyApplications {
        ...propertyApplication
      }
    }
  }
  ${Fragments.property}
  ${Fragments.propertyContext}
  ${Fragments.propertyUserGroup}
  ${Fragments.propertyApplication}
`;

export const PROPERTY_TYPES_QUERY = gql`
  query propertyTypes {
    propertyTypes {
      dictionaryItemId
      dictionaryItemName
      dictionaryItemCode
    }
  }
`;

export const PROPERTY_CATEGORIES_QUERY = gql`
  query propertyCategories {
    propertyCategories {
      dictionaryItemId
      dictionaryItemName
      dictionaryItemCode
    }
  }
`;

export const CONTEXTS_QUERY = gql`
  query contexts {
    contexts {
      dictionaryItemId
      dictionaryItemName
      dictionaryItemCode
    }
  }
`;

export const APPLICATIONS_QUERY = gql`
  query applicationsConfig {
    applicationsConfig {
      appCode
      appName
    }
  }
`;

export const PAGED_DETAILS_QUERY = gql`
  query PagedDetails(
    $propertyId: Int!
    $pager: PagerInput
    $filters: DetailFilterInput
    $paginationPager2: PagerInput
    $paginationFilters2: DetailFilterInput
  ) {
    pagedDetails(propertyId: $propertyId, pager: $pager, filters: $filters) {
      values {
        propertyDetailId
        propertyId
        propertyValue
        orderNo
        description
        inactive
        code
      }
      pagination(pager: $paginationPager2, filters: $paginationFilters2) {
        currentIndex
        totalCount
        prevPage {
          afterId
          sortBy
          direction
          pageSize
        }
        nextPage {
          afterId
          sortBy
          direction
          pageSize
        }
      }
    }
  }
`;
